import { SearchableDropdownSelect } from '../web-components/searchable-dropdown-select';
import { closeDrawer } from './drawer-component';

export async function launchShelterSelectionModal(): Promise<string | null> {
  return new Promise((resolve) => {
    modifyPlaceholder();
    const handle = document.createElement('button');
    handle.setAttribute('data-drawer-trigger', 'true');
    handle.setAttribute('data-controls', 'drawer-shelter-selector');
    handle.setAttribute('aria-expanded', 'false');
    document.body.appendChild(handle);
    handle.click();

    window.addEventListener('shelter:selected', (event) => {
      if (event instanceof CustomEvent) {
        resolve(event.detail.shelter as string);
        handle.remove();
      }
    });

    window.addEventListener('shelter:denied', () => {
      resolve(null);
      handle.remove();
    });
  });
}

function modifyPlaceholder() {
  const shadow = document.querySelector(
    'searchable-dropdown-select'
  )?.shadowRoot;

  if (!shadow) {
    return;
  }

  const input = shadow.querySelector('.searchable_select__input input');

  if (input) {
    input.setAttribute('placeholder', 'Start typing your shelter’s name…...');
  }
}

const updateTheDrawerMessage = (selections: string[]) => {
  const message = document.querySelector('.drawer__content__message');
  if (!message) {
    return;
  }

  if (selections.length > 0) {
    message.classList.remove('hidden');
    return;
  }

  message.classList.add('hidden');
};

const confirmShelterSelection = (selections: string[]) => {
  if (!selections.length) {
    return;
  }

  const shelter = selections[0];

  const event = new CustomEvent('shelter:selected', {
    detail: {
      shelter,
    },
  });

  window.dispatchEvent(event);
};

export const initShelterSelector = () => {
  const shelterSelector =
    document.querySelector<SearchableDropdownSelect>('.shelter-selector');
  const drawer = document.querySelector('.drawer--shelter-selector');
  if (!drawer) {
    return;
  }

  const confirmButton = drawer.querySelector('.button-save-and-continue');
  const drawerCloseButtons = drawer.querySelectorAll('[data-drawer-close]');

  confirmButton?.addEventListener('click', (e) => {
    e.preventDefault();
    if (shelterSelector && 'selected' in shelterSelector) {
      confirmShelterSelection(shelterSelector.selected);
      confirmButton.setAttribute('data-busy', 'true');
    }
  });

  document.addEventListener('cart-drawer:opened', () => {
    closeDrawer(drawer);

    confirmButton?.removeAttribute('data-busy');
    shelterSelector?.clear();
    confirmButton?.setAttribute('disabled', 'true');
  });

  drawerCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const event = new CustomEvent('shelter:denied', {
        detail: {
          shelter: null,
        },
      });

      window.dispatchEvent(event);
    });
  });

  const disableButton = (disabled = false) => {
    if (confirmButton instanceof HTMLButtonElement) {
      confirmButton.disabled = disabled;
    }
  };

  shelterSelector?.addEventListener('change', (event) => {
    if (!(event instanceof CustomEvent)) {
      return;
    }

    updateTheDrawerMessage(event.detail.selected);

    disableButton(event.detail?.value.trim() === '');
  });
};
